import { combineReducers } from "redux";
import loadUser from "./user.reducer";

const reducer = combineReducers({
  userState: loadUser
});

export default reducer;
